import { render, staticRenderFns } from "./Fader.vue?vue&type=template&id=6f774663"
import script from "./Fader.vue?vue&type=script&lang=js"
export * from "./Fader.vue?vue&type=script&lang=js"
import style0 from "./Fader.vue?vue&type=style&index=0&id=6f774663&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports